import React from 'react';
import 'react-toggle/style.css';
import styled from 'styled-components';

import IRhapsodyServer from 'src/ServerEntities/IRhapsodyServer';
import IQVeraAlert from 'src/ServerEntities/IQVeraAlert';
import ErrorBox from 'src/SharedComponents/ErrorBox';
import LoadingIndicator from 'src/SharedComponents/LoadingIndicator';
import { SessionContext } from 'src/Views/SessionContext';
import { getRhapsodyHeader, getQVeraAlerts } from '../ramService';
import { ContentContainer } from '../Intersystems/IntersystemsDashboard';
import QVeraAlertItem from './QVeraAlertItem';
import ServerSelector from 'src/SharedComponents/Select/ServerSelector';

const SiteContainer = styled.ul`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: stretch;
    margin-top: 20px;
`;

interface IProps {
    selectedTypes: string[],
    changeRole: boolean,
    setChangeRole: (changeRole: boolean) => void
};

const OuterContainer = styled.div`
    width: 1050px;
    border-radius: 25px;
    border: 5px solid #44A2D6;
    padding: 2px;
    height: 100%;
`;

const InnerContainer = styled.table`
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 20px;
    width: 100%;
`;

const TitleBar = styled.div`
    width: 1035px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background-color: #1577AE;
    padding: 5px;
    padding-left: 10px;
    color: #FFF;
    text-align: left;
    font-size: 1.2em;
    font-weight: bold;
`;

const QVeraAlerts = (props: IProps) => {
    const { state, dispatch } = React.useContext(SessionContext);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [alerts, setAlerts] = React.useState(undefined as unknown as IQVeraAlert[]);
    const [data, setData] = React.useState(undefined as unknown as IRhapsodyServer[]);
    const selectedServer = state.selectedSever ?? 0;

    const setSelectedServer = (index: number) => {
        dispatch({ type: "setSelectedServer", payload: index });
    };
    const headerInfo = state.headerInfo ? state.headerInfo : data as IRhapsodyServer[];
    
    React.useEffect(() => {
        if (!state.headerInfo) {
            setLoading(true);
            getRhapsodyHeader(state.webToken, (serverData: IRhapsodyServer[]) => {
                setLoading(false);
                setError("");
                setData(serverData);
                dispatch({ type: "setHeaderInfo", payload: serverData });
                loadAlerts(serverData);
            }, (errorMessage: string) => {
                setLoading(false);
                setError(errorMessage);
            });
        } else {
            loadAlerts(headerInfo);
        }
    }, [state.webToken]);

    const loadAlerts = (header: IRhapsodyServer[]) => {
        if (header && header[selectedServer]) {
            setLoading(true);
            getQVeraAlerts(header[selectedServer].id, state.webToken, (data: IQVeraAlert[]) => {
                setLoading(false);
                setAlerts(data);
                setError("");
            }, (errorMessage: string) => {
                setLoading(false);
                setError(errorMessage);
            });
        }
    }

    React.useEffect(() => {
        if (headerInfo) {
            loadAlerts(headerInfo);
        }
    }, [selectedServer]);

    const renderAlert = (alert: IQVeraAlert, index: number) => {
        return <QVeraAlertItem key={`qvera-alert-item-${index}`} alert={alert} />;
    };

    return <ContentContainer>
        <LoadingIndicator type="Linear" show={loading} />
        {error && <ErrorBox>{error}</ErrorBox>}
        <ServerSelector headerInfo={headerInfo} selectedServer={selectedServer} setSelectedServer={setSelectedServer}/>
        <SiteContainer>
            <OuterContainer>
                <TitleBar>Active Alerts</TitleBar>
                <InnerContainer>
                    {alerts && alerts.map(renderAlert)}
                </InnerContainer>
            </OuterContainer>
        </SiteContainer>
    </ContentContainer>;
};

export default QVeraAlerts;

